<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import layoutStore from "@shared/svelte/Stores/LayoutStore";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";

  export let isOnListsOrDealsPage: boolean;
  export let shouldDisplayTime: boolean;
  export let isOnRepRecommendationsPage: boolean;
  export let shouldShowLowStock: boolean;
  export let stock: string;
  export let showVerifiedInStock: boolean = true;
  export let isOnChooseStoreModal: boolean = false;
  export let shouldShowNoRecentUpdate: boolean = false;

  const inStock = "In stock";
  const lowStock = "Low stock";
  const outOfStock = "Out of stock";

  let noRecentUpdate: boolean;
  let shouldHideVerifiedInStock: boolean = stock === inStock && !showVerifiedInStock;

  const stockTextColor = (stock: string): string => {
    switch (stock) {
      case lowStock:
        return "fizz-text-warning";
      case outOfStock:
        return "fizz-text-negative";
      case inStock:
        return "fizz-text-positive";
    }
  };

  const iconType = (stock: string): string => {
    switch (stock) {
      case outOfStock:
      case lowStock:
        return "Info";
      case inStock:
        return "CheckCircle";
    }
  };

  $: item = Object.keys($InventoryItemStore?.inventoryItems)[0];
  $: noRecentUpdate =
    $InventoryItemStore?.inventoryItems[item]?.stock_info?.level === "No recent inventory update";
</script>

<style>
  .icon-adjustment-top {
    margin-top: 0.07rem;
  }

  .icon-adjustment-left {
    margin-left: 0rem !important;
  }

  .icon-margin-left {
    margin-left: 8px;
  }
</style>

{#if shouldShowNoRecentUpdate && noRecentUpdate}
  <!-- NoRecentUpdateTooltip -->
{:else if (!(stock === lowStock) || shouldShowLowStock) && !shouldHideVerifiedInStock}
  <span
    class="{stockTextColor(stock)} fizz-flex-row-4"
    data-testid="stock-text-container"
    class:icon-margin-left={isOnRepRecommendationsPage && $layoutStore.isDesktop}
  >
    <span class="fizz-inline-4 icon-adjustment-top">
      <Icon className="fizz-icon-16" type={iconType(stock)} />
    </span>
    <span class:icon-adjustment-left={isOnListsOrDealsPage || isOnChooseStoreModal}>{stock}</span>
    {#if shouldDisplayTime}
      <span class="fizz-text-subdued">updated 4 hrs ago</span>
    {/if}
  </span>
{/if}
